import { RouterPaths } from '@/presentation/router/RouterPathsMapper'

export const fullScreenPaths: string[] = [
  `${RouterPaths.WEIGHT_AND_BALANCE}/${RouterPaths.WEIGHT_AND_BALANCE_NEW}/${RouterPaths.WB_FLIGHT_FILLING}`,
  `${RouterPaths.WEIGHT_AND_BALANCE}/${RouterPaths.WEIGHT_AND_BALANCE_EDIT}/${RouterPaths.WB_FLIGHT_FILLING}`
]
